import { DistributionType, EstateType } from '@aviv-search/types';
// buy, buy_auction, rent are regular distribution types
// buy_rent is a custom title oriented distribution type for SEO needs
const authorizedDistributionTypes = ['buy', 'buy_auction', 'buy_rent', 'rent'];
export const titleTranslationKeyHouseApartment = 'house_apartment';
export const titleTranslationKeyFallback = 'real_estate';
const getEstateTypeTitleData = (estateTypes) => {
    // Special use case: House&Apartment
    if (estateTypes.length === 2 &&
        [EstateType.HOUSE, EstateType.APARTMENT].every((estateType) => estateTypes?.includes(estateType))) {
        return titleTranslationKeyHouseApartment;
    }
    // Special use case: generic name when 0 or more than 1 estate types are selected
    if (estateTypes?.length === 1)
        return `${estateTypes[0]}`.toLowerCase();
    return titleTranslationKeyFallback;
};
export const getTitleData = (searchModel, labels) => {
    const { distributionTypes = [], estateTypes = [], locations } = searchModel;
    // Special use case: both buy & rent are searched
    const distributionType = distributionTypes.includes(DistributionType.BUY) && distributionTypes.includes(DistributionType.RENT)
        ? 'buy_rent'
        : `${distributionTypes[0]}`.toLowerCase();
    const validatedDistributionType = authorizedDistributionTypes.includes(distributionType) ? distributionType : 'buy';
    const [firstSearchLocation] = locations;
    const radius = firstSearchLocation && 'radius' in firstSearchLocation ? firstSearchLocation.radius : undefined;
    return {
        distributionType: validatedDistributionType,
        estateType: getEstateTypeTitleData(estateTypes),
        location: {
            labels,
            ...(radius && { radius }),
        },
    };
};
